import { render, staticRenderFns } from "./admin_rczp.vue?vue&type=template&id=be216bde&scoped=true"
import script from "./admin_rczp.vue?vue&type=script&lang=js"
export * from "./admin_rczp.vue?vue&type=script&lang=js"
import style0 from "./admin_rczp.vue?vue&type=style&index=0&id=be216bde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be216bde",
  null
  
)

export default component.exports